import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import { IconField } from "primereact/iconfield";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import ModalAddClassifications from "./ModalAddProcessings";

import {
    getDataAll,
    deleteProcessing,
    setDataNull,
} from "../../store/processings/slice";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import ActionMenu2 from "../../components/ActionMenu2";
import ModelDelete from "../../components/ModalDelete";
import { formatNumber } from "../../components/utils";
import { formatDate } from "../Plan/ModalShowPlan";
import { MultiSelect } from "primereact/multiselect";
import { getDataAll as getDataAllClassification } from "../../store/classifications/slice";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import ModalImportExcel from "./ModalImportExcel";
import { exportExcel, clearDataExcel } from "../../store/Excels/slice";
import { site } from "../../api/url_helper";
import { deleteManyRequest } from "../../store/processings/slice";
import { getBuilding } from "../../store/order/slice";

export default function Processing() {
    const toast = useRef(null);
    const menuRight = useRef(null);
    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState("");
    const [dialogAddVisible, setDialogAddVisible] = useState(false);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [rowData, setRowData] = useState();
    const [modalDelete, setModalDelete] = useState(false);
    const [orderCodeValue, setOrderCodeValue] = useState("");
    const [factoryCodeValue, setFactoryCodeValue] = useState("");
    const [selectedClassification, setSelectedClassification] = useState(null);
    const [type, setType] = useState(null);
    const [visibleImportExcel, setVisibleImportExcel] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [building, setBuilding] = useState(null);
    const [buildingValue, setBuildingValue] = useState();

    const {
        loading,
        processingData,
        insertData,
        deleteData,
        updateData,
        classificationData,
        exportExcelData,
        exportError,
        deleteMany,
        dataBuilding,
    } = useSelector(
        (state) => ({
            loading: state.Processings.loading,
            processingData: state.Processings.processingData,
            insertData: state.Processings.insertData,
            deleteData: state.Processings.deleteData,
            updateData: state.Processings.updateData,
            classificationData: state.Classifications.classificationData,
            exportExcelData: state.Excel.exportExcelData.data,
            exportError: state.Excel.exportExcelData.error,
            deleteMany: state.Processings.deleteMany,
            dataBuilding: state.Production.dataBuilding,
        }),
        shallowEqual
    );

    useEffect(() => {
        if (deleteMany) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xoá thành công",
                life: 3000,
            });
        }
        dispatch(setDataNull());
    }, [deleteMany]);
    const showToast = (severity, summary, detail) => {
        toast.current?.show({ severity, summary, detail, life: 3000 });
    };
    useEffect(() => {
        if (exportExcelData) {
            const file = exportExcelData?.data;

            const fileUrl = `${site}/${file}`;
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "Sample data.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dispatch(clearDataExcel());
            showToast("success", "Thành công", "Tải thành công");
        } else if (exportError) {
            showToast(
                "error",
                "Thất bại",
                exportError?.response?.data?.message
            );
        }
    }, [exportExcelData, exportError]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            dispatch(
                getDataAll({
                    page: first / rows + 1,
                    limit: rows,
                    keyword: keyword,
                    type,
                    factoryCode: factoryCodeValue,
                    orderCode: orderCodeValue,
                    classificationIds: JSON.stringify(selectedClassification),
                    building,
                })
            );
        }, 300);

        return () => clearTimeout(timeout);
    }, [
        rows,
        first,
        keyword,
        insertData,
        deleteData,
        updateData,
        type,
        orderCodeValue,
        factoryCodeValue,
        selectedClassification,
        deleteMany,
        building,
    ]);

    useEffect(() => {
        dispatch(getDataAllClassification({ page: 1, limit: 100 }));
    }, []);

    useEffect(() => {
        if (deleteData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xoá gia công thành công",
                life: 3000,
            });
        }
        dispatch(setDataNull());
    }, [deleteData]);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const handleEdit = (rowData) => {
        setRowData(rowData);
        setDialogAddVisible(true);
    };

    const handleDelete = (rowData) => {
        setModalDelete(true);
        setRowData(rowData);
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <ActionMenu2
                onEdit={() => handleEdit(rowData)}
                onDelete={() => handleDelete(rowData)}
            />
        );
    };
    const acceptDelete = () => {
        if (rowData) {
            const id = rowData.id;

            if (id !== undefined) {
                dispatch(deleteProcessing({ id }));
            }
            setModalDelete(false);
        }
    };
    const logDataTable = () => {
        dispatch(
            exportExcel({
                type: "processing",
            })
        );
    };
    const handleClick = (event) => {
        menuRight.current.show(event);
    };
    const items = [
        {
            label: "Nhập từ excel",
            icon: "pi pi-file-excel",
            command: () => setVisibleImportExcel(true),
        },
        {
            label: "Xuất ra excel",
            icon: "pi pi-file-excel",
            command: logDataTable,
        },
    ];
    const handleSelectionChange = (e) => {
        const selected = e.value || [];
        const currentPageItems = processingData?.data?.items || [];

        // Loại bỏ các phần tử thuộc trang hiện tại khỏi selectedProducts
        const filteredProducts =
            selectedProducts?.filter(
                (item) => !currentPageItems.some((row) => row.id === item.id)
            ) || [];

        // Gộp các phần tử không bị xóa với phần tử vừa chọn
        const updatedSelection = [...filteredProducts, ...selected];

        // Loại bỏ phần tử trùng lặp
        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values()
        );

        setSelectedProducts(uniqueSelection);
    };
    const handleDeleteMany = () => {
        if (selectedProducts?.length > 0) {
            dispatch(
                deleteManyRequest({
                    type: "processing",
                    ids: selectedProducts?.map((item) => item.id),
                })
            );

            setSelectedProducts([]);
        }
    };
    useEffect(() => {
        dispatch(
            getBuilding({
                page: 1,
                limit: 100,
            })
        );
    }, [dispatch]);
    const removeDuplicates = (array, key) => {
        return array.filter(
            (item, index, self) =>
                index === self.findIndex((t) => t[key] === item[key])
        );
    };
    useEffect(() => {
        if (dataBuilding?.data?.items) {
            const buildings = dataBuilding.data.items.map((item) => ({
                label: item.name,
                value: item.id,
            }));
            setBuildingOptions(removeDuplicates(buildings, "value"));
        }
    }, [dataBuilding]);
    const handleBuildingChange = (e) => {
        setBuilding(e.target.value);
        setBuildingValue(e.target.value);
    };

    return (
        <div className="flex flex-column h-full">
            <Toast ref={toast} />
            <div className="pb-3 flex gap-4 justify-content-between">
                <div className="flex gap-4 w-full">
                    <Button
                        label="Thêm gia công"
                        style={{ height: "35px", width: "200px" }}
                        onClick={() => setDialogAddVisible(true)}
                    />
                    <IconField className="w-full">
                        <InputText
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            placeholder="Tìm kiếm"
                            className="w-full border-0"
                        />
                    </IconField>
                </div>
                <div className="flex gap-4">
                    {selectedProducts?.length > 0 && (
                        <Button
                            label="Xóa"
                            style={{ height: "35px" }}
                            onClick={() => handleDeleteMany()}
                        />
                    )}
                    <Button
                        label={"Thao tác"}
                        popup="true"
                        icon={"pi pi-sort-down-fill"}
                        onClick={handleClick}
                        aria-controls="popup_menu_right"
                        aria-haspopup
                        iconPos="right"
                        style={{ width: "200px", height: "35px" }}
                    />
                </div>
                <Menu
                    model={items}
                    popup="true"
                    ref={menuRight}
                    id="popup_menu_right"
                    popupAlignment="right"
                    style={{ minWidth: "200px" }}
                />
            </div>
            <div className="flex gap-4 pb-3">
                <IconField className="search-item">
                    <MultiSelect
                        placeholder="Lọc công trình"
                        options={buildingOptions}
                        onChange={handleBuildingChange}
                        emptyFilterMessage="Không có dữ liệu"
                        emptyMessage="Không có dữ liệu"
                        value={buildingValue}
                        filter
                        showClear
                        className="border-0 w-full"
                    />
                </IconField>
                <IconField className="search-item">
                    <InputText
                        value={orderCodeValue}
                        placeholder="Mã đơn hàng"
                        className="w-full border-0"
                        onChange={(e) => setOrderCodeValue(e.target.value)}
                    />
                </IconField>
                <IconField className="search-item">
                    <InputText
                        value={factoryCodeValue}
                        onChange={(e) => setFactoryCodeValue(e.target.value)}
                        placeholder="Lọc mã nhà máy"
                        className="w-full border-0"
                    />
                </IconField>
                <IconField className="search-item">
                    <MultiSelect
                        options={
                            Array.isArray(classificationData?.data?.items)
                                ? classificationData.data.items.map((item) => ({
                                      label: item.name,
                                      value: item.id,
                                  }))
                                : []
                        }
                        value={selectedClassification}
                        onChange={(e) => setSelectedClassification(e.value)}
                        placeholder="Lọc theo phân loại"
                        className="w-full border-0"
                        showClear
                    />
                </IconField>
                <IconField className="search-item">
                    <Dropdown
                        options={[
                            { label: "Nguyên vật liệu", value: "NVL" },
                            { label: "Gia công", value: "GC" },
                        ]}
                        placeholder="Lọc theo loại"
                        showClear
                        value={type}
                        onChange={(e) => setType(e.value)}
                    />
                </IconField>
            </div>
            <div className="bg-white border-round-md shadow-1 p-3 h-full flex flex-column justify-content-between">
                <DataTable
                    value={processingData?.data?.items}
                    emptyMessage="Không có dữ liệu"
                    loading={loading}
                    size="small"
                    scrollHeight="65vh"
                    scrollable
                    dataKey="id"
                    rowClassName="custom-row-class"
                    onSelectionChange={handleSelectionChange}
                    selectionMode="checkbox"
                    selection={selectedProducts || []}
                >
                    <Column selectionMode="multiple"></Column>
                    <Column
                        header="STT"
                        body={(rowData, options) => (
                            <div className="text-center">
                                {first + options.rowIndex + 1}
                            </div>
                        )}
                        style={{ width: "1%", minWidth: "20px" }}
                        alignHeader={"center"}
                        align={"center"}
                    ></Column>
                    <Column
                        header="Tên công trình"
                        field="Building"
                        style={{ width: "5%", minWidth: "150px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.Material?.Product?.Building?.name}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Mã đơn hàng"
                        field="orderCode"
                        style={{ width: "5%", minWidth: "150px" }}
                        body={(rowData) => (
                            <div>{rowData?.Material?.Product?.orderCode}</div>
                        )}
                    ></Column>
                    <Column
                        header="Code vật tư"
                        field="name"
                        style={{ width: "5%", minWidth: "150px" }}
                        body={(rowData) => <div>{rowData?.Material?.code}</div>}
                    ></Column>
                    <Column
                        header="Phân loại"
                        field="code"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{rowData?.Material?.Classification?.name}</div>
                        )}
                    ></Column>
                    <Column
                        header="YCVT sô BRAVO"
                        field="price"
                        style={{ width: "5%", minWidth: "200px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.Material?.materialRequestNumber}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="YCVT số PR"
                        field="materialRequestNumber"
                        style={{ width: "5%", minWidth: "120px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.Material?.materialRequestNumberPr}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Po"
                        field="po"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="NCC"
                        field="supplier"
                        style={{ width: "5%", minWidth: "150px" }}
                    ></Column>
                    <Column
                        header="Khu vực"
                        field="orderCode"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{rowData?.Material?.Product?.orderCode}</div>
                        )}
                    ></Column>
                    <Column
                        header={
                            <div>
                                <div>Tên SP</div>
                                <div>Mã SP</div>
                            </div>
                        }
                        field="unit"
                        style={{ width: "5%", minWidth: "250px" }}
                        body={(rowData) => (
                            <div>
                                <div>
                                    {rowData?.Material?.Product?.categoryName}
                                </div>
                                <div className="mt-2">
                                    {rowData?.Material?.Product?.categoryCode}
                                </div>
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Quy cách tính"
                        field="calculationMethod"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="Mã nhà máy"
                        field="Classification"
                        style={{ width: "5%", minWidth: "150px" }}
                        body={(rowData) => (
                            <div>{rowData?.Material?.Product?.factoryCode}</div>
                        )}
                    ></Column>
                    <Column
                        header="ĐVT"
                        field="unit"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => <div>{rowData?.Material?.unit}</div>}
                    ></Column>
                    <Column
                        header="Tổng SL yêu cầu"
                        field="quantity"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{formatNumber(rowData?.quantity)}</div>
                        )}
                        align={"right"}
                    ></Column>
                    <Column
                        header="SL đã về"
                        field="factoryCode"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.isFinished
                                    ? formatNumber(rowData?.quantity)
                                    : 0}
                            </div>
                        )}
                        align={"right"}
                    ></Column>
                    <Column
                        header="Còn lại"
                        field="factoryCode"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.isFinished
                                    ? 0
                                    : formatNumber(rowData?.quantity)}
                            </div>
                        )}
                        align={"right"}
                    ></Column>
                    <Column
                        header="Còn lại"
                        field="factoryCode"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div className="mr-2">
                                {rowData?.isFinished ? "100%" : "0%"}
                            </div>
                        )}
                        align={"right"}
                    ></Column>
                    <Column
                        header="Người ĐX"
                        field="proposedBy"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="PC mua hàng"
                        field="purchasing"
                        style={{ width: "5%", minWidth: "150px" }}
                    ></Column>
                    <Column
                        header="Ngày gửi YCVT"
                        field="requestSentDate"
                        style={{ width: "5%", minWidth: "130px" }}
                        body={(rowData) => (
                            <div>{formatDate(rowData?.requestSentDate)}</div>
                        )}
                    ></Column>
                    <Column
                        header="Ngày YC có hàng theo YCVT"
                        field="expectedArrivalDate"
                        style={{ width: "10%", minWidth: "200px" }}
                        body={(rowData) => (
                            <div>
                                {formatDate(rowData?.expectedReceiveDate)}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Ghi chú"
                        field="description"
                        style={{ width: "6%", minWidth: "150px" }}
                    ></Column>
                    <Column
                        header="Ngày nhập kho gần nhất"
                        field="importWarehouseDate"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>
                                {formatDate(rowData?.importWarehouseDate)}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Báo huỷ"
                        field="cancel"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header={
                            <div>
                                <div>Done</div>
                                <div>Chưa done</div>
                            </div>
                        }
                        field="cancel"
                        style={{ width: "5%", minWidth: "100px" }}
                        align={"center"}
                        body={(rowData) => (
                            <div>{rowData?.isDone ? "Done" : "Chưa done"}</div>
                        )}
                    ></Column>
                    <Column field="action" body={actionBodyTemplate}></Column>
                </DataTable>
                <div className="card">
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={processingData?.data?.totalItems}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
            <ModalAddClassifications
                visible={dialogAddVisible}
                onHide={() => {
                    setDialogAddVisible(false);
                    setRowData(null);
                }}
                toast={toast}
                rowData={rowData}
            />
            <ModelDelete
                visible={modalDelete}
                setVisible={setModalDelete}
                accept={acceptDelete}
                msg={
                    <div style={{ textAlign: "center" }}>
                        Bạn chắc chắn muốn xóa hạng mục này?
                        <br />
                        Các thông tin liên quan đến hạng mục này sẽ bị xóa.
                    </div>
                }
            />
            <ModalImportExcel
                visible={visibleImportExcel}
                onHide={() => setVisibleImportExcel(false)}
                type="processing"
            />
        </div>
    );
}
